import React from 'react';
import { PropTypes } from 'prop-types';

import { ButtonRound, Field } from '@ontruck/orc';

import DatePickerCalendar from 'components/form/DatePickerCalendar';
import { isEmpty } from 'utils/types';
import ResponsiveModal from 'components/ResponsiveModal';

const DateField = ({
  className,
  value,
  extraClassName,
  responsiveModalRef,
  t,
  handleClear,
  handleChange,
  type,
  minDate,
  maxDate,
}) => (
  <div className={`${className} ${extraClassName}`}>
    <ResponsiveModal
      modalRef={responsiveModalRef}
      refProperty="fieldRef"
      footer={t('footer')}
      alignRight={type === 'last_dropoff_time'}
      content={
        <DatePickerCalendar
          minDate={minDate}
          maxDate={maxDate}
          handleChange={handleChange}
        />
      }
    >
      <Field
        type="text"
        id={type}
        name={type}
        value={value}
        label={t(`label_dates_filter_${type}`)}
        size="L"
        fullWidth
        readOnly
      />
    </ResponsiveModal>

    {!isEmpty(value) && (
      <span className="icon">
        <ButtonRound
          skin="primary"
          size="XXS"
          icon="close"
          onClick={handleClear}
        />
      </span>
    )}
  </div>
);

DateField.propTypes = {
  t: PropTypes.func,
  className: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.string,
  extraClassName: PropTypes.string,
  handleChange: PropTypes.func,
  handleClear: PropTypes.func,
  responsiveModalRef: PropTypes.func,
  minDate: PropTypes.instanceOf(Date),
  maxDate: PropTypes.instanceOf(Date),
};

DateField.defaultProps = {
  t: () => {},
  className: '',
  type: '',
  value: '',
  extraClassName: '',
  handleChange: () => ({}),
  handleClear: () => ({}),
  responsiveModalRef: () => ({}),
  minDate: undefined,
  maxDate: undefined,
};

export default DateField;
